import React, { Fragment } from 'react';

import { addStylesToSchema } from '@/exceed';
import { ModificationTrackingForm } from 'core/forms';
import pick from 'lodash/pick';

import { Typo } from 'uikit/content';

import styles from '../styles/initiativeForm.module.scss';

const InitiativeForm = ({
  model,
  onLoad,
  onSubmit,
  onUpdate,
  schemas,
}) => (
  schemas.map(({ schema, title }) => (
    <Fragment key={title}>
      <Typo className={styles.title} element="h2" variant="h5" weight="medium">
        {title}
      </Typo>
      <ModificationTrackingForm
        className={styles.section}
        model={pick(model, Object.keys(schema))}
        modifiedClassName={styles.isModified}
        onFormLoad={onLoad}
        onSaveClick={onSubmit}
        onFormUpdate={onUpdate}
        schema={addStylesToSchema(schema, styles)}
      />
    </Fragment>
  ))
);

export default React.memo(InitiativeForm);
